import type {
  IKeyholderDataWeb,
  IUpdateKeyholderBillingProfileBody,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

const updateKeyholderBillingProfile = async ({
  billingProfile,
  resetPaymentStatus = false,
}: {
  billingProfile: IKeyholderDataWeb;
  resetPaymentStatus?: boolean;
}): Promise<IKeyholderDataWeb> => {
  const { data } = await axios.post<
    IKeyholderDataWeb,
    AxiosResponse<IKeyholderDataWeb>,
    IUpdateKeyholderBillingProfileBody
  >('/supra/billing_profile', { billingProfile, resetPaymentStatus });
  return data;
};

export default updateKeyholderBillingProfile;
